/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Newsletter options container.
 *
 * The `default` preset supplies client-side fallbacks. In the Page Designer
 * flow the server (form/presets/newsletter.js) emits localized `errorMessage`
 * and `emailInvalidMessage` via the `amb-newsletter` options blob, so these
 * defaults mostly cover direct / non-PD usage. Success copy is rendered
 * server-side and is not part of the options blob.
 */
export const newsletterOptions = {
  /**
   * @returns {object}
   */
  default() {
    return {
      /**
       * Email validation pattern (string form so it can be overridden via
       * the options blob). Compiled to a RegExp in the directive.
       *
       * @type {string}
       */
      emailPattern: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$',

      /**
       * reCAPTCHA v3 action name (ignored by v2). Kept for forward-compat.
       *
       * @type {string}
       */
      recaptchaAction: 'newsletter',

      /**
       * Whether server-side email deliverability validation is enabled (server
       * sets this via the options blob; defaults to on).
       *
       * @type {boolean}
       */
      emailValidationEnable: true,

      /**
       * CRM lead FirstName (not shown on the storefront).
       *
       * @type {string}
       */
      firstName: 'Website',

      /**
       * CRM lead Surname (not shown on the storefront).
       *
       * @type {string}
       */
      surname: 'News Subscriber',

      /**
       * Forced preview state from Page Designer Edit mode (`auto` = live).
       *
       * @type {string}
       */
      previewState: 'auto',

      /**
       * @type {string}
       */
      errorMessage: '',

      /**
       * @type {string}
       */
      emailInvalidMessage: ''
    };
  }
};
